import {callAPI} from './commonBusiness';
import {ApiRouteMap} from '../../constants/dataEnum';

export const readDispenseReports =
  (page = 0, pageSize = 1000, isDownloaded = null, isCompleted = null, userIdParam = null, isOwner = null) =>
  async (dispatch, getState) => {
    const state = getState();
    const {configState, sessionState} = state;
    const baseUrl = configState.hubHost.urlAuthoringLocation;
    const {userId} = sessionState.user;

    let queryString = `?userId=${userId ?? userIdParam}&pageIdx=${page}&pageSize=${pageSize}`;

    if (isDownloaded !== null) {
      queryString = `${queryString}&isDownloaded=${isDownloaded}`;
    }

    if (isCompleted !== null) {
      queryString = `${queryString}&isCompleted=${isCompleted}`;
    }

    if (isOwner !== null) {
      queryString = `${queryString}&isOwner=${isOwner}`;
    }

    try {
      const response = await callAPI('GET', baseUrl, `${ApiRouteMap.READ_DISPENSE_REPORTS}${queryString}`);

      return response;
    } catch (err) {
      return err?.response?.data;
    }
  };

export const elaborateLastDispenseReport =
  (userIdParam = null) =>
  async (dispatch, getState) => {
    const state = getState();
    const {configState, sessionState} = state;
    const baseUrl = configState.hubHost.urlAuthoringLocation;
    const {userId} = sessionState.user;

    try {
      const response = await callAPI(
        'GET',
        baseUrl,
        `${ApiRouteMap.ELABORATE_LAST_DISPENSE_REPORTS}?userId=${userId ?? userIdParam}`,
      );
      return response;
    } catch (err) {
      return err?.response?.data;
    }
  };

export const updateDispenseReport =
  (id, propertyMap, userIdParam = null) =>
  async (dispatch, getState) => {
    const state = getState();
    const {configState, sessionState} = state;
    const baseUrl = configState.hubHost.urlAuthoringLocation;
    const {userId} = sessionState.user;

    try {
      const response = await callAPI(
        'PUT',
        baseUrl,
        `${ApiRouteMap.UPDATE_DISPENSE_REPORT}?userId=${userId ?? userIdParam}&reportId=${id}`,
        propertyMap,
      );

      return response;
    } catch (err) {
      return err?.response?.data;
    }
  };

export const deleteDispenseReports = (ids) => async (dispatch, getState) => {
  const state = getState();
  const {configState, sessionState} = state;
  const baseUrl = configState.hubHost.urlAuthoringLocation;
  const {userId} = sessionState.user;

  try {
    const response = await callAPI('DELETE', baseUrl, `${ApiRouteMap.DELETE_DISPENSE_REPORTS}?userId=${userId}`, ids);

    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const downloadDispenseReports =
  (ids, userIdParam = null) =>
  async (dispatch, getState) => {
    const state = getState();
    const {configState, sessionState} = state;
    const baseUrl = configState.hubHost.urlAuthoringLocation;
    const {userId} = sessionState.user;

    try {
      const response = await callAPI(
        'POST',
        baseUrl,
        `${ApiRouteMap.DOWNLOAD_DISPENSE_REPORTS}?userId=${userId ?? userIdParam}`,
        ids,
      );

      return response;
    } catch (err) {
      return err?.response?.data;
    }
  };

export const getLastDispenseReport =
  (isDownloaded = null, isCompleted = null, userIdParam = null) =>
  async (dispatch) => {
    const reportResult = await dispatch(readDispenseReports(0, 1, isDownloaded, isCompleted, userIdParam, true));

    if (reportResult?.payload?.items) {
      const report = reportResult.payload.items[0];

      if (report) {
        const downloadReportResult = await dispatch(downloadDispenseReports([report.id], userIdParam));

        if (downloadReportResult?.payload?.length > 0) {
          return downloadReportResult.payload[0];
        }
      }
    }

    return null;
  };
